'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'head-side-brain';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f808';
var svgPathData = 'M224 0C100.3 0 0 100.3 0 224 0 281.8 22 334.6 58 374.3 62.2 379 64 384 64 388.1L64 488c0 13.3 10.7 24 24 24s24-10.7 24-24l0-99.9c0-18.1-7.8-34.2-18.5-46-28.3-31.2-45.5-72.6-45.5-118.1 0-97.2 78.8-176 176-176 86.6 0 158.7 62.6 173.3 145.1 .9 4.8 3.2 9.3 6.7 12.8l52.2 52.2c5 5 7.9 11.9 7.9 19 0 14.9-12 26.9-26.9 26.9L424 304c-13.3 0-24 10.7-24 24l0 48c0 22.1-17.9 40-40 40l-48 0c-13.3 0-24 10.7-24 24l0 48c0 13.3 10.7 24 24 24s24-10.7 24-24l0-24 24 0c48.6 0 88-39.4 88-88l0-24.8c36.2-5.3 64-36.5 64-74.1 0-19.9-7.9-38.9-21.9-53l-47-47C421.5 75.9 331.7 0 224 0zm16 96c-12.3 0-23.5 4.6-32 12.2-8.5-7.6-19.7-12.2-32-12.2-26.5 0-48 21.5-48 48-26.5 0-48 21.5-48 48s21.5 48 48 48c.7 0 1.3 0 2 0 7.1 27.6 32.2 48 62 48 35.3 0 64-28.7 64-64l48 0c26.5 0 48-21.5 48-48s-21.5-48-48-48l-18.7 0c-6.6-18.6-24.4-32-45.3-32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHeadSideBrain = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;